import {
  defaultLanguage,
  languages
} from "../localization/languages/languages";
import { AlternateLink } from "../localization/alternateLinks";
import { I18nPaths } from "types/gatsby";
import { legacyUrl } from "./legacyUrl";
import { DefaultMetadataFragment } from "types/graphql-types";
import { Language } from "../localization/languages/types";

export const buildI18nPathsFromSanityPath = (
  node: {
    _id?: string;
    metadata?: DefaultMetadataFragment;
  },
  slugPrefix?: string
): I18nPaths => {
  if (!node?.metadata?.routing?.path)
    throw `No path in Sanity for page: ${node._id}`;
  return languages.reduce((result, language) => {
    const path = node?.metadata?.routing?.path?.[language.sanityCode];
    if (!path) return result;

    let pathWithPrefix: string | undefined = undefined;
    if (slugPrefix) {
      const paths = path.split("/").reverse();
      paths[0] = `${slugPrefix}-${paths[0]}`;
      pathWithPrefix = paths.reverse().join("/");
    }

    return {
      ...result,
      [language.code]: {
        language,
        path: pathWithPrefix || path
      }
    };
  }, {});
};

export function i18nPaths2AlternateLinks(
  i18nPaths: I18nPaths
): AlternateLink[] {
  const paths = Object.values(i18nPaths);
  return paths.reduce<AlternateLink[]>((links, i18nPath) => {
    const path = legacyUrl(i18nPath.path);
    if (path) {
      links.push({
        ogLangCode: i18nPath.language.ogLang,
        path
      });
    }
    return links;
  }, []);
}

export const addSubPath =
  (path: I18nPaths) =>
  (subPath: string): I18nPaths =>
    languages.reduce(
      (acc, lang) => ({
        ...acc,
        [lang.code]: {
          ...path[lang.code],
          path: `${path[lang.code].path}${subPath}`
        }
      }),
      path
    );

export function checkRoutingIsValid(page: {
  metadata?: DefaultMetadataFragment;
}): boolean {
  return !!page?.metadata?.routing?.path;
}

export const languageSpecificHomepagePath = (language: Language) =>
  defaultLanguage == language ? "/" : `/${language.path}`;

export const languageSpecificPath = (
  path: string,
  language: Language,
  prefix = ""
) =>
  defaultLanguage == language
    ? `${prefix}${path}`
    : `${prefix}/${language.path}${path}`;

export const appendBToI18nPaths = (i18nPaths: I18nPaths): I18nPaths => {
  const langs = Object.keys(i18nPaths);
  return langs.reduce<I18nPaths>((links, lang) => {
    const paths = i18nPaths[lang];
    links[lang] = {
      ...paths,
      path: `${paths.path}-b`
    };
    return links;
  }, {});
};
